import React, { useState, useEffect } from "react";
import "./App.css";
import { Routes, Route } from "react-router-dom";
import { Home } from "./pages/home/Home";
import { About } from "./pages/about/About";
import { Cid } from "./pages/cid/Cid";
import { SignUp } from "./pages/signup/SignUp";
import { CreateSpPins } from "./pages/createSpPins/CreateSpPins";
import { Navbar } from "./components/navbar/Navbar";
import { Footer } from "./components/footer/Footer";
import { EarlyAccess } from "./components/earlyAccess/EarlyAccess";
import { Faqs } from "./pages/faq/Faqs";
import { MoneyManagement } from "./pages/moneyManagement/MoneyManagement";
import { Investment } from "./pages/investment/Investment";
import { SmartSavings } from "./pages/smartSavings/SmartSavings";
import { SavingsStage } from "./pages/savingsStage/SavingsStage";
import { AnnualSavings } from "./pages/annualSavings/AnnualSavings";
import { ShortTermSaving } from "./pages/shortTermSaving/ShortTermSaving";
import { TargetGoal } from "./pages/targetGoal/TargetGoal";
import { LongTermSavings } from "./pages/longTermSavings/LongTermSavings";
import { GroupTargetSavings } from "./pages/groupTargetSavings/GroupTargetSavings";
import { AutomaticDebiting } from "./pages/features/AutomaticDebiting";
import { TargetSavings } from "./pages/features/TargetSavings";
import { DigitalWallet } from "./pages/features/DigitalWallet";
import { InvestDollars } from "./pages/features/InvestDollars";
import { SavingPlanPin } from "./pages/features/SavingPlanPin";
// import { SpecialSavings } from "./pages/features/SpecialSavings";
import { TargetSavingGoals } from "./pages/features/TargetSavingGoals";
import { VirtualDebitCard } from "./pages/features/VirtualDebitCard";
import { Congrats } from "./pages/comingSoon/Congrats";
import { ComingSoon } from "./pages/comingSoon/ComingSoon";
import { AutoPlay } from "./AutoPlay";
import { Maintenance } from "./Maintenance";



const App = () => {
  return (
    <div className="App">
        <>
          <Navbar />
          <Routes>
            {/* <Route path="/" element={<Maintenance />} /> */}
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/cid" element={<Cid />} />
            <Route path="/create-sp" element={<CreateSpPins />} />
            <Route path="/sign-up" element={<SignUp />} />
            <Route path="/faqs" element={<Faqs />} />
            <Route path="/earlyaccess" element={<EarlyAccess />} />
            <Route path="/money-management" element={<MoneyManagement />} />
            <Route path="/investment" element={<Investment />} />
            <Route path="/smart-savings" element={<SmartSavings />} />
            <Route path="/savings-stage" element={<SavingsStage />} />
            <Route path="/annual-savings" element={<AnnualSavings />} />
            <Route path="/short-term-savings" element={<ShortTermSaving />} />
            <Route path="/target-goal" element={<TargetGoal />} />
            <Route path="/long-term-goal" element={<LongTermSavings />} />
            <Route
              path="/group-target-savings"
              element={<GroupTargetSavings />}
            />
            <Route path="/automatic-debiting" element={<AutomaticDebiting />} />
            <Route path="/target-savings" element={<TargetSavings />} />
            <Route path="/digital-wallet" element={<DigitalWallet />} />
            <Route path="/invest-dollars" element={<InvestDollars />} />
            <Route path="/save-plan-pin" element={<SavingPlanPin />} />
            <Route path="/target-savings" element={<TargetSavings />} />
            <Route
              path="/target-saving-goals"
              element={<TargetSavingGoals />}
            />
            <Route path="/virtual-debit-card" element={<VirtualDebitCard />} />
            <Route path="/congrats" element={<Congrats />} />
            <Route path="/coming-soon" element={<ComingSoon />} />
            <Route path="/a" element={<AutoPlay />} />
          </Routes>
          <Footer />
        </>
    </div>
  );
}

export  default App;
